// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"814":"21b32225","901":"8b1c4213","918":"445e4e0d"}[chunkId] + ".chunk.css";
};